import { layout } from 'thewest/App.routing'
import { metrics } from 'component-library/__styling/settings'

import { ArticleV4DTO } from 'publication-types'
import { TheWestSection } from 'component-library/__styling/settings/sections/thewest'

export const getAmpArticleComposition = (article: ArticleV4DTO, section: TheWestSection) =>
    layout.composition({
        type: 'box',
        props: {
            containerWidth: metrics.thewest.mainContentWidth,
            horizontalGutters: 'unset',
            verticalGutters: ['unset', 'unset'],
        },
        contentAreas: {
            main: [
                layout.component({
                    type: 'amp-sticky-ad-unit',
                    props: {
                        slot: {
                            id: 'amp-article-sticky-footer',
                            size: 'leaderboard',
                            pageType: 'article',
                        },
                    },
                }),
                layout.component({
                    type: 'article',
                    props: {
                        meta: {
                            slug: article.slug,
                            kind: 'article',
                            inlinePublicationContent: [
                                {
                                    kind: 'ad',
                                    insertAfter: 3,
                                    content: [
                                        {
                                            noticePosition: 'none',
                                            hiddenUntilLoaded: true,
                                            slot: {
                                                id: 'amp-article-mrec-one',
                                                size: 'mobileMrec',
                                                pageType: 'article',
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        dataDefinitionArgs: {
                            publicationId: article.id,
                        },
                        section,
                    },
                }),
            ],
        },
    })
